import { render } from "./IndexPage.vue?vue&type=template&id=6495a9a8&ts=true"
import script from "./IndexPage.vue?vue&type=script&lang=ts"
export * from "./IndexPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__